package com.anjuros.website.templates.template5.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.sections.Template5Badge
import com.anjuros.website.templates.template5.util.ResKey
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template5SectionTitle(
    badge: ResKey,
    title: ResKey,
    text: ResKey,
    modifier: Modifier = Modifier
) {

    Column(
        modifier = modifier
            .fillMaxWidth()
            .margin(bottom = 60.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Template5Badge(
            text = LocalText(badge)
        )

        H2(
            attrs = Modifier
                .fontSize(48.px)
                .fontWeight(FontWeight.Bold)
                .lineHeight(1.2)
                .textAlign(TextAlign.Center)
                .color(Template5Theme.Primary.getColor())
                .margin(
                    top = 24.px,
                    bottom = 20.px
                )
                .toAttrs()
        ) {
            Text(LocalText(title))
        }

        P(
            attrs = Modifier
                .maxWidth(720.px)
                .fontSize(18.px)
                .lineHeight(1.8)
                .textAlign(TextAlign.Center)
                .color(rgb(120, 120, 120))
                .margin(0.px)
                .toAttrs()
        ) {
            Text(LocalText(text))
        }

    }

}